<template>
  <div class="MsgForm">
    <div class="form_wrap">
      <span class="title"> 供应商资质 </span>
      <div class="btn_wrap">
        <img src="@/assets/img/btn_add.png" alt @click="add('qualificationList')" />
        <img src="@/assets/img/btn_delete.png" alt @click="removeRualification" />
      </div>
      <table>
        <tbody>
          <tr>
            <th width="40px">
              <el-checkbox v-model="allQualificationCheck"></el-checkbox>
            </th>
            <th width="200px">基础资质类别</th>
            <th width="180px">资质文件名称</th>
            <th width="180px">资质有效期</th>
            <th width="300px">资质状态</th>
            <th width="150px" v-if="auditStatus">操作</th>
          </tr>
          <tr v-for="(item, index) in qualificationList" :key="index">
            <td>
              <el-checkbox v-model="item.check" v-if="!item.IsMust"></el-checkbox>
            </td>
            <td>
              <span v-if="item.IsMust">
                <span class="icon_must">*</span>

                <span> {{ item.QualificationTypeName }}</span>
              </span>
              <el-input v-model="item.QualificationTypeName" v-if="!item.IsMust" :disabled="!auditStatus"></el-input>
            </td>
            <td>
              <span
                class="filename"
                @click="download(item.FileId, item.Remark, item.QualificationName)"
                v-if="item.FileId !== 0 || item.Remark !== ''"
                >{{ item.QualificationName }}</span
              >
            </td>

            <td class="custom_date custom_daterange">
              <el-date-picker
                :disabled="!auditStatus"
                v-model="item.ServiceLifeDate"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                unlink-panels
                @change="ServiceLifeDateChange(index)"
              ></el-date-picker>
            </td>
            <td>
              <el-radio-group v-model="item.QualificationStatus" :disabled="true">
                <el-radio :label="1">生效</el-radio>
                <el-radio :label="0">失效</el-radio>
              </el-radio-group>
            </td>

            <td class="operation" v-if="auditStatus">
              <span class="files">
                <span class="oText">上传附件</span>
                <input type="file" class="avatar" name="avatar" accept=".pdf" @change="upload(index)" />
              </span>
              <span class="link" @click="deleteFile(index, 1)" v-if="item.FileId !== '0' || item.Remark !== ''">删除附件</span>
              <span class="template" @click="downloadTemplate(item.TemplatefilePath, item.FileName)" v-if="item.TemplatefilePath">下载模板</span>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="line"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    FileList: Array,
    auditStatus: {
      type: Boolean,
      default: true
    },
    TaxPayerSize: String
  },
  data() {
    return {
      value: '',
      allQualificationCheck: '',
      allEnclosureCheck: '',
      qualificationList: [],
      enclosureList: [],
      list: [],
      iserror: true,
      file: {
        check: false,
        CertificateNo: null,
        FileId: 0,
        FileName: '',
        FileType: 1,
        FileTypeName: '一般纳税人资格证明',
        IsMust: true,
        IssuingAuthority: null,
        QualificationId: 0,
        Remark: '',
        ServiceLifeDate: ['', ''],
        IsLongServiceDate: false,
        TemplatefilePath: ''
      }
    }
  },
  watch: {
    allQualificationCheck(val) {
      this.qualificationList.forEach((element) => {
        if (element.hasOwnProperty('check')) {
          element.check = val
        }
      })
    },
    FileList(val) {
      this.qualificationList = this.FileList
    }
  },
  mounted() {
    this.qualificationList = this.FileList
  },
  methods: {
    add(name) {
      const obj = {
        check: false,
        QualificationTypeName: '',
        FileId: 0,
        QualificationName: '',
        IsMust: false,
        QualificationId: 0,
        Remark: '',
        ServiceLifeDate: ['', ''],
        QualificationStatus: ''
      }

      this.qualificationList.push(obj)
    },
    removeRualification() {
      this.qualificationList = this.qualificationList.filter((item) => {
        return !item.check
      })
    },

    download(fileId, remark, fileName) {
      let token = window.localStorage.getItem('loginToken')
      var url = 'SupplierLogin/DownLoadFile?fileId=' + fileId + '&remark=' + remark + '&token=' + token + '&fileName=' + fileName

      this.downloadfile(this.baseURL + url)
    },
    downloadTemplate(TemplatefilePath, FileName) {
      var url = 'SupplierLogin/DownloadTemplate?TemplatefilePath=' + TemplatefilePath + '&FileName=' + FileName
      this.downloadfile(this.baseURL + url)
    },
    upload(index) {
      let filesDom = document.getElementsByClassName('avatar')[index]
      const file = filesDom.files[0]
      var name = file.name
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      // const extension = testmsg.toLowerCase() === 'pdf'
      // if (!extension) {
      //   this.$message.error('请上传pdf文件！')
      //   filesDom.value = ''
      //   return
      // }
      // if (file.size > 200 * 1024 * 1024) {
      //   this.$message.error('请上传小于200M的文件！')
      //   filesDom.value = ''
      //   return
      // }
      var formData = new window.FormData()
      formData.append('file', file)

      this.uploadFileRequest('SupplierLogin/UploadFile', formData).then((res) => {
        if (res.data.errcode == 0) {
          this.qualificationList[index].FileId = res.data.fileid
          this.qualificationList[index].QualificationName = name
          this.qualificationList[index].Remark = ''
          filesDom.value = ''
        }
      })
    },

    deleteFile(index, flag) {
      if (flag == 1) {
        this.qualificationList[index].FileId = 0
        this.qualificationList[index].Remark = ''
      }
    },
    ruleList() {
      this.list = []
      this.iserror = true

      this.qualificationList.forEach((item) => {
        if (item.FileId == 0 && item.Remark == '' && this.iserror && item.IsMust == true) {
          this.$message.error('请上传(' + item.QualificationTypeName + ')资质')
          this.iserror = false
          return false
        }
        if (item.FileId > 0) {
          if (!item.QualificationStatus && this.iserror) {
            this.$message.error('请填写(' + item.FileTypeName + ')资质状态')
            this.iserror = false
            return false
          }
          if ((!item.ServiceLifeDate || !item.ServiceLifeDate[0] || (!item.ServiceLifeDate[1] && item.IsLongServiceDate === false)) && this.iserror) {
            this.$message.error('请填写(' + item.QualificationTypeName + ')资质有效期')
            this.iserror = false
            return false
          }
        }
      })

      this.list.push(...this.qualificationList.filter((m) => m.FileId != 0 || m.Remark != ''))
    },
    ruleList1() {
      this.list = []
      this.list.push(...this.qualificationList.filter((m) => m.FileId != 0 || m.Remark != ''))
    },
    ServiceLifeDateChange(index) {
      if (new Date(this.qualificationList[index].ServiceLifeDate[1]).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0)) {
        this.qualificationList[index].QualificationStatus = 1
      } else {
        this.qualificationList[index].QualificationStatus = 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.operation {
  align-items: center;

  .files {
    position: relative;
    flex: 1;

    .oText {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      line-height: 23px;
      cursor: pointer;
    }

    input {
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      opacity: 0;
      cursor: pointer;
    }
  }

  .template {
    flex: 1;
  }
}

.link {
  cursor: pointer;
}

.filename {
  cursor: pointer;
  white-space: nowrap;
  width: 80%;
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline-block;
  color: #0066cc;
}

.filename2 {
  width: auto;
}

.tips {
  font-size: 14px;
  color: #ff6600;
}

.icon_tips2 {
  margin-right: 3px;
  margin-left: 6px;
  vertical-align: bottom;
}

// .filedate{width:65%}
// .custom_date ::v-deep.el-date-editor {
//   width: 49% !important;
// }
.custom_date ::v-deep.el-range-editor {
  width: 100% !important;
}

.custom_daterange ::v-deep.el-range-input {
  height: 34px;
  line-height: 34px;
  font-size: inherit;
}

.custom_daterange ::v-deep.el-date-editor {
  height: auto;
}

.datepicker_wrap {
  border: 1px solid #ccc;
  background: #fff;
  border-radius: 3px;
}

.datepicker_wrap ::v-deep.el-input__inner {
  border: none !important;
  border-radius: 4px;
  background: #fff;
}

.filedate2 ::v-deep.el-input__prefix {
  .el-icon-date {
    position: relative;
  }

  .el-icon-date:before {
    content: '';
    width: 4px;
    height: 1px;
    position: absolute;
    top: 50%;
    left: 0;
    background: #303133;
    clear: both;
  }
}

.filedate2 ::v-deep.el-input__inner {
  padding-left: 24px !important;
}

.filedate2 ::v-deep.el-input__prefix {
  left: -4px;
}

.filedate1 ::v-deep.el-input__prefix {
  left: -3px;
}

.filedate1 ::v-deep.el-input__inner {
  padding-left: 40px !important;
  padding-right: 40px !important;
  text-align: center;
}

.filedate1 ::v-deep.el-input__icon {
  line-height: 33px;
}

.popover_1 {
  margin-left: 15px;
  color: darkorange;

  .icon_tips2 {
    padding-right: 5px;
  }

  .icon_must {
    font-weight: bold;
    margin-right: 5px;
    color: #f56c6c;
  }
}
</style>